import {Component, Input} from '@angular/core';

@Component({
    selector: 'wba-ueberschrift-kachel',
    templateUrl: './wba-ueberschrift-kachel.component.html',
    styleUrls: ['./wba-ueberschrift-kachel.component.css'],
    standalone: false
})
export class WbaUeberschriftKachelComponent {

  @Input()
  zaehler: number;
  @Input()
  anzeigetext: string;
}
